import React from 'react';
import { Chip, ChipProps } from '@mui/material';

export type StatusType = {
  label: string;
  color: string;
  backgroundColor: string;
};

export type StatusConfig = Record<string, StatusType>;

interface StatusChipProps extends Omit<ChipProps, 'label'> {
  label?: string;
  status?: string;
  backgroundColor?: string;
  statusConfig?: StatusConfig;
}

const StatusChip: React.FC<StatusChipProps> = ({
  label,
  status,
  statusConfig = {},
  ...props
}) => {
  const statusStyle = statusConfig?.[status as keyof StatusConfig] ?? null;

  return (
    <Chip
      label={label || statusStyle?.label}
      sx={{
        color: statusStyle?.color,
        backgroundColor: statusStyle?.backgroundColor,
        borderRadius: '16px',
        height: '24px',
        fontSize: '12px',
        fontWeight: 500,
        ...props.sx
      }}
      {...props}
    />
  );
};

export default StatusChip; 